import StorageUtils from './StorageUtils'
import { isExpired } from "react-jwt"

class AuthService {
    /**
     * 判断用户是否登录
     */
    isLogin() {
        const { access, refresh } = StorageUtils.getUser()
        const accessTokenIsExpired = isExpired(access)
        const refreshTokenIsExpired = isExpired(refresh)
        
        if (refreshTokenIsExpired) {
            StorageUtils.removeUser()
        }

        if (!refreshTokenIsExpired || !accessTokenIsExpired) {
            return true
        }

        return false
    }
}

export default new AuthService()